export const ICON_LIST = [
  '2impactsLess',
  '2or3impacts',
  '3impactsMore',
  'XCircle',
  'accident',
  'accueil',
  'adas',
  'aichat',
  'alert',
  'angry',
  'apple_map',
  'arrow_bottom',
  'arrow_left',
  'arrow_right',
  'arrow_top',
  'bell',
  'big_arrow_left',
  'big_arrow_right',
  'bigger2cm',
  'book_appointment',
  'bus',
  'calendar_hour',
  'cancel',
  'cancel_alt',
  'car',
  'car_alert',
  'check',
  'check_bis',
  'close',
  'comments',
  'conveying',
  'copy',
  'crack',
  'cube',
  'deaf',
  'delete',
  'device',
  'document',
  'drag_drop',
  'edit',
  'emoji_congratz',
  'emoji_eyes',
  'emoji_indic',
  'emoji_question',
  'emoji_sad',
  'emoji_scream',
  'emoji_trust',
  'emoji_uneasy',
  'euro',
  'excel',
  'exchange',
  'export',
  'external_link',
  'eye',
  'fitter',
  'folder',
  'four_cm',
  'franceparebrise_global_bigger4cm',
  'franceparebrise_global_check_bis',
  'franceparebrise_global_smaller4cm',
  'franceparebrise_phone_cta',
  'franceparebrise_replacement_vehicle',
  'franceparebrise_search_fitter',
  'franceparebrise_search_home',
  'franceparebrise_vehicle_type_page_bus',
  'franceparebrise_vehicle_type_page_car',
  'franceparebrise_vehicle_type_page_tractor',
  'franceparebrise_vehicle_type_page_truck',
  'franceparebrise_vehicle_type_page_utility',
  'franceparebrise_vehicle_type_page_van',
  'frown',
  'gear',
  'geoloc',
  'google_logo',
  'google_map',
  'group',
  'help',
  'home',
  'impact',
  'inbox',
  'info',
  'insurer',
  'itinerary',
  'laugh',
  'like',
  'lines_horizontal',
  'logout',
  'macif_calendar_add',
  'macif_calendar_date_picker',
  'macif_calendar_edit',
  'macif_earliest_more_mobile',
  'macif_global_accident',
  'macif_global_alert',
  'macif_global_arrow_bottom',
  'macif_global_arrow_left',
  'macif_global_arrow_right',
  'macif_global_arrow_top',
  'macif_global_calendar_hour',
  'macif_global_cancel',
  'macif_global_cancel_alt',
  'macif_global_car',
  'macif_global_check',
  'macif_global_check_bis',
  'macif_global_close',
  'macif_global_copy',
  'macif_global_delete',
  'macif_global_edit',
  'macif_global_exchange',
  'macif_global_eye',
  'macif_global_gear',
  'macif_global_geoloc',
  'macif_global_home',
  'macif_global_info',
  'macif_global_itinerary',
  'macif_global_like',
  'macif_global_logout',
  'macif_global_map_location',
  'macif_global_more',
  'macif_global_password',
  'macif_global_phone',
  'macif_global_picture_preview',
  'macif_global_road',
  'macif_global_search',
  'macif_global_star',
  'macif_global_time',
  'macif_global_user',
  'macif_global_warning_circle',
  'macif_global_wrench_AND_fitter',
  'macif_insurance_cover_zone_money',
  'macif_map_location_clickable',
  'macif_phone_cta',
  'macif_replacement_vehicle',
  'maif_global_XCircle',
  'maif_global_accident',
  'maif_global_alert',
  'maif_global_arrow_bottom',
  'maif_global_arrow_left',
  'maif_global_arrow_right',
  'maif_global_arrow_top',
  'maif_global_big_arrow_left',
  'maif_global_big_arrow_right',
  'maif_global_calendar_hour',
  'maif_global_car',
  'maif_global_check',
  'maif_global_check_bis',
  'maif_global_close',
  'maif_global_crack',
  'maif_global_delete',
  'maif_global_document',
  'maif_global_edit',
  'maif_global_exchange',
  'maif_global_eye',
  'maif_global_folder',
  'maif_global_garage',
  'maif_global_geoloc',
  'maif_global_help',
  'maif_global_home',
  'maif_global_impact',
  'maif_global_info',
  'maif_global_itinerary',
  'maif_global_like',
  'maif_global_map_location',
  'maif_global_money',
  'maif_global_more',
  'maif_global_part_diameter',
  'maif_global_phone',
  'maif_global_picture_preview',
  'maif_global_plaque',
  'maif_global_road',
  'maif_global_time',
  'maif_global_unlink',
  'maif_global_upload',
  'maif_global_user',
  'maif_info_filled',
  'mail',
  'map',
  'map_location',
  'matmut_global_delete',
  'meh',
  'menu',
  'money',
  'more',
  'more_horiz',
  'no_show_appointment',
  'operation_vitre',
  'ornikar_appointment_selection_sheet_book',
  'ornikar_info_badge_info',
  'ornikar_no_appointment_header',
  'ornikar_upload_end_page',
  'other_vehicle',
  'part_diameter',
  'password',
  'phone',
  'phone_call',
  'picture_preview',
  'pin',
  'planning',
  'plaque',
  'plus',
  'printer',
  'public_works_vehicle',
  'reduce',
  'result',
  'road',
  'save',
  'search',
  'smaller2cm',
  'smile',
  'star',
  'time',
  'time_later',
  'tour_dot',
  'tractor',
  'trophy',
  'truck',
  'unlink',
  'upload',
  'user',
  'utility',
  'van',
  'visibility_black',
  'visibility_off_black',
  'vision_field',
  'warning_circle',
  'waze',
  'wrench',
  'zoom_in',
  'zoom_out',
] as const;
export type IconName = typeof ICON_LIST[number];
